<template>
  <div>
    <!--推荐商品维护  -->
    <baseBreadcrumb :page="$t('message.recommendedProducts')" :menu="$t('message.operationAndMaintenance')" />
    <div class="body">
      <div class="btn">
        <!-- 同步到首页 -->
        <el-button type="primary" @click="synchronizationRecommendedGoods">{{ $t('message.SyncHome') }}</el-button>
      </div>
      <div class="table">
        <ol>
          <!-- 排序 -->
          <li class="flex05">{{ $t('message.sort') }}</li>
          <!-- 商品链接 -->
          <li>{{ $t('message.ProductLink') }}</li>
          <!-- 展示图片 -->
          <li>{{ $t('message.displayImages') }}</li>
          <!-- 商品标题（中文） -->
          <li>{{ $t('message.commodityTitle') }}（中文）</li>
          <!-- 商品标题（译文） -->
          <li>{{ $t('message.commodityTitle') }}（译文）</li>
          <!-- 操作 -->
          <li>{{ $t('message.operation') }}</li>
        </ol>
        <ul v-for="(item, index) in list" :key="index">
          <!-- 排序 -->
          <li class="flex05">{{ item.sort }}</li>
          <!-- 商品链接 -->
          <li>
            <p>
              <a :href="item.url" target="_blank" rel="noopener noreferrer" class="a-link">
                {{ item.url }}
              </a>
            </p>
          </li>
          <!-- 展示图片 -->
          <li>
            <el-image :src="item.imgUrl" style="width: 150px;height: 150px;"
              :preview-src-list="[item.imgUrl]"></el-image>
          </li>
          <!-- 商品标题（中文） -->
          <li>
            <p>{{ item.original_title }}</p>
          </li>
          <!-- 商品标题（译文） -->
          <li>{{ item.title }}</li>
          <!-- 操作 -->
          <li>
            <!-- 编辑 -->
            <el-button size="small" type="danger" @click="showEdit(item)">{{ $t('message.redact') }}</el-button>
            <!-- 上移 -->
            <el-button size="small" type="primary" icon="el-icon-sort-up" @click="moveItem(1, index, item.id)"
              v-if="index > 0">{{
                $t('message.moveUp') }}</el-button>
            <!-- 下移 -->
            <el-button size="small" type="primary " icon="el-icon-sort-down" @click="moveItem(2, index, item.id)"
              v-if="list.length - 1 > index">{{
                $t('message.moveDown') }}
            </el-button>
          </li>
        </ul>
      </div>
    </div>
    <!-- 修改商品 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="650px" center>
      <!-- 商品链接 -->
      <div class="productLink">
        <div class="title">{{ $t('message.ProductLink') }}</div>
        <div class="row">
          <el-input v-model="itemData.url"></el-input>
          <!-- 获取商品信息 -->
          <el-button type="primary" @click="getGoodsInfo">{{ $t('message.getProductInfo') }}</el-button>
        </div>
      </div>
      <!-- 编辑商品 -->
      <div class="editGoods">
        <div class="items">
          <!--  商品原图  -->
          <div class="goodsTitle">
            {{ $t("message.originalGoods") }}
          </div>
          <img :src="itemData.original_imgUrl" alt="" />
        </div>
        <div class="icon">
          <img src="@/assets/icon/replace.png" alt="" />
        </div>
        <div class="items">
          <div class="goodsTitle">
            <!--    展示图片 -->
            {{ $t("message.displayImages") }}
            <el-upload class="upload-demo" drag action="#" :show-file-list="false" :http-request="httpup"
              :before-upload="beforeAvatarUpload">
              <div class="el-upload__text">
                <i class="el-icon-upload"></i><em>{{ $t("message.uoloadPic") }}</em>
              </div>
            </el-upload>
          </div>
          <img :src="itemData.imgUrl" alt="" />
        </div>
        <div class="items">
          <div class="goodsTitle">
            <!--商品原名称-->
            {{ $t("message.originalNameCommodity") }}
          </div>
          <el-input type="textarea" v-model="itemData.original_title" resize="none" show-word-limit readonly>
          </el-input>
        </div>
        <div class="icon">
          <img src="@/assets/icon/replace.png" alt="" />
        </div>
        <div class="items">
          <div class="goodsTitle">
            <!-- : '译文编辑' -->
            {{ $t("message.translationEditing") }}
          </div>
          <el-input type="textarea" v-model="itemData.title" resize="none" show-word-limit onfocus="this.select()"
            maxlength="200">
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <el-button type="primary" @click="recommendGoodsListUpdate">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      dialogVisible: false,
      itemData: {},
    };
  },
  created() {
    this.recommendGoodsList()
  },
  methods: {
    recommendGoodsList() {
      this.$api.siteConfiguration.recommendGoodsList().then(res => {
        this.list = res.data
      })
    },
    //同步到首页
    synchronizationRecommendedGoods() {
      this.$api.siteConfiguration.synchronizationRecommendedGoods().then(res => {
        this.$message.success(res.msg)
      })
    },
    // 移动一个
    moveItem(type, index, id) {
      if (type == 1) {
        this.list = this.moveUp(this.list, index)
      } else {
        this.list = this.moveDown(this.list, index)
      }
      this.$forceUpdate()
      let datas = {
        type,
        id
      }
      this.$api.siteConfiguration.recommendGoodsMove(datas).then(res => {
        this.$forceUpdate()
      })
    },
    // 上移函数（将元素向上移动一位）
    moveUp(arr, index) {
      if (index <= 0 || index >= arr.length) {
        return arr; // 已经在最上面或索引无效，直接返回原数组
      }

      // 创建新数组避免修改原数组
      const newArray = [...arr];
      // 交换当前元素和前一个元素的位置
      [newArray[index - 1], newArray[index]] = [newArray[index], newArray[index - 1]];

      return newArray;
    },
    // 下移函数（将元素向下移动一位）
    moveDown(arr, index) {
      if (index < 0 || index >= arr.length - 1) {
        return arr; // 已经在最下面或索引无效，直接返回原数组
      }
      // 创建新数组避免修改原数组
      const newArray = [...arr];
      // 交换当前元素和后一个元素的位置
      [newArray[index], newArray[index + 1]] = [newArray[index + 1], newArray[index]];
      return newArray;
    },
    //推荐商品修改
    recommendGoodsListUpdate() {
      this.$api.siteConfiguration.recommendGoodsListUpdate(this.itemData).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.recommendGoodsList()
      })
    },
    // 显示修改
    showEdit(item) {
      let data = JSON.parse(JSON.stringify(item));
      this.itemData = {
        id: data.id,
        url: data.url,
        original_title: data.original_title,
        title: data.title,
        original_imgUrl: data.original_imgUrl,
        imgUrl: data.imgUrl,
        goodsPrice: data.goodsPrice,
      }
      this.dialogVisible = true;
    },
    // 获取商品信息
    getGoodsInfo() {
      if (this.itemData.url == '') return this.$message.error('请输入商品链接')
      this.$api.siteConfiguration.getGoodsInfo({ url: this.itemData.url }).then(res => {
        this.itemData.title = res.data.title
        this.itemData.original_title = res.data.title
        this.itemData.original_imgUrl = res.data.imgUrl
        this.itemData.imgUrl = res.data.imgUrl
        this.itemData.goodsPrice = res.data.goodsPrice
      })
    },
    // 图片上传事件
    async httpup(file) {
      let data = await this.createClient(file)
      this.itemData.imgUrl = data.data
      this.$forceUpdate()
    },
    // 图片格式
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      this.loading = true;
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG和PNG 和svg格式!");
        this.loading = false;
      }
      return isJPG || isPNG || isSVG;
    },
  }
}
</script>
<style lang='scss' scoped>
.btn {
  margin-bottom: 24px;
  text-align: right;
}

.table {
  .flex05 {
    flex: 0.3;
  }

  li {
    margin-right: 15px;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }
}

.productLink {
  .title {
    text-align: left;
  }

  .row {
    display: flex;
    margin-bottom: 24px;

    .el-button {
      margin-left: 24px;
    }
  }
}

.editGoods {
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px;

  .items {
    width: 240px;
    margin: 0 0 10px 0;

    .goodsTitle {
      height: 48px;
      line-height: 48px;
      margin-bottom: 15px;
      width: 240px;
      position: relative;

      /deep/ .el-upload {
        width: 160px;
        height: 50px;
        position: absolute;
        top: 0;
        right: 0;
      }

      /deep/.el-upload-dragger {
        background-color: #fff9ef;
        width: 160px;
        height: 50px;
        border-color: #ffa200;

        .el-upload__text {
          width: 160px;
          height: 50px;

          .el-icon-upload {
            margin: 0;
            font-size: 25px;
            vertical-align: middle;
            margin-right: 10px;
            color: #ffa200;
          }

          em {
            color: #ffa200;
          }
        }
      }
    }

    img {
      height: 240px;
      width: 240px;
    }
  }

  .icon {
    width: 80px;
    text-align: center;
    padding-top: 183px;

    img {
      width: 25px;
      transform: rotate(180deg);
    }
  }

  /deep/ .el-textarea__inner {
    height: 240px;

    &:focus {
      background-color: #f2f8fb;
    }
  }
}
</style>